import axios from 'axios';

type ProductType = 'orgBilling' | 'appointmentDesk' | undefined;

export const createStripeCustomerId = async (
  productType?: ProductType,
  userId?: string,
) => {
  const { data: customerId } = await axios.post<string>(
    `/billing/stripe_customer_id`,
    {
      params: {
        productType,
        userId,
      },
    },
  );

  return customerId;
};
